module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    class: {
      'card-flat': true,
      'card--flipped': _vm.isFlipped,
      'card--horizontal': _vm.orientation == 'horizontal',
        'card--vertical': _vm.orientation != 'horizontal',
    },
    on: {
      "click": function($event) {
        _vm.handleClick($event)
      }
    }
  }, [_c('section', {
    staticClass: "card-panel"
  }, [_c('section', {
    staticClass: "card-side-front"
  }, [_vm._t("card-front")], 2), _vm._v(" "), _c('section', {
    staticClass: "card-side-back"
  }, [_vm._t("card-back")], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ce559964","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/photo-card.vue
// module id = 38
// module chunks = 0